/* ========================================================================
 * DOM-based Routing
 * Based on http://goo.gl/EUTi53 by Paul Irish
 *
 * Only fires on body classes that match. If a body class contains a dash,
 * replace the dash with an underscore when adding it to the object below.
 *
 * .noConflict()
 * The routing is enclosed within an anonymous function so that you can
 * always reference jQuery with $, even when in .noConflict() mode.
 * ======================================================================== */

var htmlElement = document.querySelector('html');
htmlElement.classList.remove('no-js');
htmlElement.classList.add('js');

(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var Sage = {
    // All pages
    'common': {
      init: function() {
        // JavaScript to be fired on all pages
        var $html = $('html');

        // --> Activate the tray-control
        var $tray = $('.tray');
        var $trayControl = $('.tray-control');

        $trayControl.on('click', function(){
          $html.toggleClass('has-active-tray');
          $tray.toggleClass('tray--active');
        });

        // --> Initialize WOW animations
        var wow = new WOW();
        wow.init();

        // --> Make embedded videos responsive
        $('.oembed').fitVids();

        // --> Activate the Testimonials carousel
        $('.testimonials-carousel').slick({
          autoplay: true,
          autoplaySpeed: 8000,

          dots: false,
          arrows: false,
          infinite: true,
          slidesToShow: 1,
        });

      },
      finalize: function() {
        // JavaScript to be fired on all pages, after page specific JS is fired
        if (typeof pca !== 'undefined') {
          pca.on('load', function(product, id, control){
            if(product === 'capture+'){
              var $lookup;

              var $fields = $();
              var $predictable = $();

              var hasValueCount = 0;

              var $show = $('<span class="pca-predict__show">Click to show address fields.</span>');

              control.fields.forEach(function(field){
                if(field.mode === 1){
                  $lookup = $('#' + field.element);

                  $show.on('click', function(){
                    $predictable.addClass('pca-predictable--show');
                  });

                  control.listen('populate', function(){
                    $predictable.addClass('pca-predictable--show').addClass('pca-predictable--filled');
                  });
                } else {
                  var $field = $('#' + field.element);

                  $fields = $fields.add($field);
                  if($field.val().length){ hasValueCount++; }
                }
              });

              $predictable = $fields.parents('.form-row');
              $predictable.addClass('pca-predictable');

              if(hasValueCount > 2){
                $predictable.addClass('pca-predictable--show');
              } else {
                $show.appendTo($lookup.parents('.form-row').first());
              }
            }
          });
        }
      }
    },
    // Home page
    'home': {
    },
    'single-product': {
      init: function(){
        $('.variations_form').each(function(){
          var $form = $(this);

          var price = { $el: $('.entry-summary .price') };
          price.default_html = price.$el.html();

          $form.on('show_variation', function(e, data){
            if (data.price_html.length) {
              price.$el.html(data.price_html);
            }
          });

          $form.on('reset_data', function(e){
            price.$el.html(price.default_html);
          });
        });
      }
    }
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = Sage;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // Fire page-specific init JS, and then finalize JS
      $.each(document.body.className.split(/\s+/), function(i, classnm) {
        UTIL.fire(classnm);
        UTIL.fire(classnm, 'finalize');
      });

      // Fire common finalize JS
      UTIL.fire('common', 'finalize');
    }
  };

  // Load Events
  $(document).ready(UTIL.loadEvents);

})(jQuery); // Fully reference jQuery after this point.
